import React, {useEffect,useState, useReducer} from 'react';
import useGoogleCaptcha from '../../components/useReCaptcha.js';
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
import {getDomain, isForbiddenDomainName} from '../../helpers/helpers.js'

import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtApiFullScanStartResults, RtCVEScanPageResult} from '../../../../server/routes/cve-security-scan.js'

// Interface for component props
interface CVEScanProps {
    server: string;
    pageData: unknown;
}

// Interface for CVE scan form props
interface CVEScanFormProps {
    reCaptchaSiteKey: string;
    props: RtCVEScanPageResult;
    google: wts_approved_any;
}

// Declare global grecaptcha object
// declare global {
//     interface Window {
//         grecaptcha: {
//             getResponse(): string;
//             reset(): void;
//         };
//     }
//     var grecaptcha: {
//         getResponse(): string;
//         reset(): void;
//     };
// }

export default function Scan({server, pageData}: CVEScanProps) {

    let [data, setData] = useState(pageData as RtCVEScanPageResult);
    const google = useGoogleCaptcha();

	return (
        <>
             <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                        <h3 style={{wordWrap: 'break-word'}}>{data.CVE}</h3>
                            <p>
                            {data.CVEDescription}
                            </p>
                       </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                        <h3 className="text-left mb-3">
                                <b>Security Scan</b>
                             </h3>
                            <CVEScanForm    
                                props={data}
                                reCaptchaSiteKey={data.ReCaptchaSiteKey}
                                google={google}
                                /> 
                        </div>
                    </div>       
                </div> 
            </section>
   
        </>
    )
}

function CVEScanForm({reCaptchaSiteKey, props, google}: CVEScanFormProps) {

    const success_msg = props.CanTestCVE ? `Run a security scan to test target domain for ${props.CVE}` : '';
    const error_msg = props.CanTestCVE ? '' : `Our system cannot test for ${props.CVE}`;
   

    const initialFlashProps: FlashMessageData = {
        success_msg: success_msg,
        error_msg: error_msg,
    }

    const [flashProps, setFlashProps] = useState(initialFlashProps);

	const CVE = props.CVE;
	// const domain = props.Domain;
    const showCaptcha = props.ShowCaptcha;

    useEffect(() => { 
		return () => {
			let script = document.getElementById('googleCaptchaScript');
			if (script) {
				script.remove();
			}
		}				
	},[google])       
    function SendCVEScan (cve: string, domain: string, deepScan: boolean, permissionToScan: boolean, captcha: wts_approved_any): void {
        var requestBody = JSON.stringify({
			cve, domain, deepScan, permissionToScan, captcha
            });

// https://127.0.0.1:3001/cve-security-scan/CVE-2024-40597/api-scan/microformats.org
    
        fetch( `/cve-security-scan/api-scan`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: requestBody
        }).then((result: Response) => {
            return result.json();
        }).then((untypedData: unknown) => {
            const data = untypedData as APIResponse<RtApiFullScanStartResults>;
           if (data.results && data.results.status == 'started') { 

				// // https://127.0.0.1:3001/cve/CVE-2024-40597/api-scan-results/example.com	
				document.location = `/cve-security-scan/${CVE}/results?scanid=${data.results.scanId}`;   
            } else {
                if (data.err)
                {
                    setFlashProps({error_msg: data.err});
                } 
                else {
                    setFlashProps({error_msg: "Scan failed"});
                }
            }
            if (showCaptcha) {
                grecaptcha.reset();
            }
        }).catch((e: unknown) => {
            console.error( "Exception", e );
        });
    };   
    /*
	function getDomain(value) {

		var regExp = /^(?:https?:\/\/)*((?:[a-z0-9-.]+)+\.[a-z]+)(?:.*)?$/g;
		var match = regExp.exec(value.trim());
		if (match !== null) {
			return match[1];
		}
		return null;
	}
        */
    function handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        const captcha = !!showCaptcha ? grecaptcha.getResponse() : undefined;
        const form = event.currentTarget;
        const domainElement = form.elements.namedItem('domain') as HTMLInputElement;
		const domain = getDomain(domainElement.value);
        const deepScanElement = form.elements.namedItem('deepScan') as HTMLInputElement;
        const deepScan = deepScanElement ? deepScanElement.checked : false;
        const permissionElement = form.elements.namedItem('permissionToScan') as HTMLInputElement;
        const permissionToScan = permissionElement.checked;

        setFlashProps({})

		if (domain != null){
			if (isForbiddenDomainName(domain)) {
                setFlashProps({error_msg: "Scanning of this website is not permitted"});
			} else {

                if (showCaptcha && !captcha) {
                    setFlashProps({error_msg: "Please select CAPTCHA"})
                }
                else {

                    SendCVEScan(
                        CVE,
                        domain,
                        deepScan,
                        permissionToScan,
                        captcha);
                }
			}
		} else {
            setFlashProps({error_msg:"Please enter a valid domain name"})
		}
   
      }
    return (     
        <> 
        <form action='#' method="GET" onSubmit={handleSubmit} >
            <div className="form-group">
                <FlashMessages props={flashProps} />
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="cve"
                    name="cve"
                    className="form-control"
                    aria-label="CVE"
                    placeholder="CVE"
                    required
					readOnly
					value={`${props.CVE}`}
                />                
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="domain"
                    name="domain"
                    className="form-control"
                    aria-label="Please provide the website to test for CVE vulnerability"
                    placeholder="Please provide the website to test for CVE vulnerability"
                    required
                />                
            </div>    
            <div className="form-group">
				<input type="checkbox" id="permissionToScan" name="permissionToScan"/>
				{' '}
				<label htmlFor="permissionToScan"> 
				I am authorized to conduct security scans on this domain.
				</label>
				<br/>
			</div>   
             {/**
            <div className="form-group">
				<input type="checkbox" id="deepScan" name="deepScan"/>
				{' '}
				<label htmlFor="deepScan"> 
				Execute a deep scan (Deep scan may take upto 3 minutes vs 30 seconds for a quick scan)
				</label>
				<br/>
			</div>  
              */}
            {
                !!showCaptcha &&
                <div className="form-group" style={{ display: "flex" }}>
                    <div style={{ marginLeft: 'auto'}}
                        className="g-recaptcha" 
                        id="captcha1"
                        data-sitekey={reCaptchaSiteKey}>
                    </div>
                </div>   
            }
            <div className="form-group" style={{ display: "flex" }}>
               <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Scan Domain</button>
            </div>
        </form>        
    </>
   )
}
